import { z } from "zod";

export const tierSchema = z.enum(["explorer", "adventurer", "globetrotter", "mavip"]);
export type Tier = z.infer<typeof tierSchema>;

export const rewardsActivitySchema = z.object({
  id: z.string(),
  title: z.string(),
  cityName: z.string().nullable(),
  delta: z.number().int(),
  createdAt: z.string(),
});
export type RewardsActivity = z.infer<typeof rewardsActivitySchema>;

/** One-off first-booking bonus. Spendable the moment it is claimed. */
export const WELCOME_BONUS_POINTS = 100;
export const WELCOME_BONUS_KEY = "welcome-first-booking";

export const welcomeBonusSchema = z.object({
  /**
   * claimable  — has a live booking, never claimed
   * claimed    — already paid, never offer again
   * ineligible — no qualifying booking (or none we can match to this account)
   */
  status: z.enum(["claimable", "claimed", "ineligible"]),
  points: z.number().int().positive(),
});
export type WelcomeBonus = z.infer<typeof welcomeBonusSchema>;

export const rewardsSummarySchema = z.object({
  points: z.number().int().nonnegative(),          // spendable (redeemable)
  pendingPoints: z.number().int().nonnegative(),   // earned, not yet spendable
  lifetimePoints: z.number().int().nonnegative(),  // drives tier
  tier: tierSchema,
  nextTierThreshold: z.number().int().positive(),
  welcomeBonus: welcomeBonusSchema,
  recentActivity: z.array(rewardsActivitySchema),
});
export type RewardsSummary = z.infer<typeof rewardsSummarySchema>;

export const rewardRuleTileSchema = z.object({
  id: z.string(),
  label: z.string(),
  points: z.number().int(),
});
export const rewardRuleGroupSchema = z.object({
  id: z.string(),
  title: z.string(),
  subtitle: z.string(),
  icon: z.string(),
  tiles: z.array(rewardRuleTileSchema),
});
export type RewardRuleGroup = z.infer<typeof rewardRuleGroupSchema>;

export const redeemOptionSchema = z.object({
  id: z.string(),
  label: z.string(),
  pointsCost: z.number().int().positive(),
  icon: z.string(),
});
export type RedeemOption = z.infer<typeof redeemOptionSchema>;
